var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-auto article-preview w-100 h-100"},[_c('mobile-box',{staticClass:"mobile-box",attrs:{"content":_vm.previewContent,"cover":_vm.coverUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }